module.exports = __webpack_public_path__ + "static/bch-icon-qrcode-16d9c1c4da90c895631141dbf8cd0706.png";